module.exports = __webpack_public_path__ + "static/media/dawn.9685d7c2.png";